
import { defineComponent } from 'vue'
import { createValidations } from '@/helpers/commons/validationHelper'
import { AxiosResponse } from 'axios'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import rolesManagementTabViewDescriptor from '../../RolesManagementTabViewDescriptor.json'
import roleDetailValidationDescriptor from './RoleDetailValidationDescriptor.json'

export default defineComponent({
    name: 'detail-tab',
    components: {
        Card,
        Dropdown,
        Checkbox,
        KnValidationMessages
    },
    props: {
        selectedRole: {
            type: Object,
            requried: false
        },
        publicRole: {
            type: Object,
            requried: false
        }
    },
    emits: ['fieldChanged', 'roleTypeChanged'],
    data() {
        return {
            rolesManagementTabViewDescriptor,
            roleDetailValidationDescriptor,
            translatedRoleTypes: [] as any,
            v$: useValidate() as any,
            roleTypes: [] as any,
            role: {} as any
        }
    },
    validations() {
        return {
            role: createValidations('role', roleDetailValidationDescriptor.validations.role)
        }
    },
    async created() {
        if (this.selectedRole) {
            this.role = { ...this.selectedRole } as any
        }
        await this.loadRoleTypes()
    },
    watch: {
        selectedRole() {
            this.v$.$reset()
            this.role = { ...this.selectedRole } as any
        }
    },
    methods: {
        async loadRoleTypes() {
            await this.loadDomains('ROLE_TYPE').then((response: AxiosResponse<any>) => {
                this.roleTypes = response.data
                this.translatedRoleTypes = response.data.map((roleType) => {
                    return {
                        VALUE_CD: this.$t(`managers.rolesManagement.rolesDropdown.${roleType.VALUE_CD}`),
                        VALUE_ID: roleType.VALUE_ID
                    }
                })
            })
        },
        onFieldChange(fieldName: string, value: any) {
            this.$emit('fieldChanged', { fieldName, value })
        },
        loadDomains(type: string) {
            return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `domains/listValueDescriptionByType?DOMAIN_TYPE=${type}`)
        },
        onRoleTypeChange(roleTypeIDField: string, roleTypeCDField: string, event) {
            const selRoleType = this.roleTypes.find((roleType) => roleType.VALUE_ID === event.value)
            if (selRoleType) {
                this.role.roleTypeCD = selRoleType.VALUE_CD
            }
            const ID = event.value
            const CD = this.role.roleTypeCD
            this.$emit('roleTypeChanged', { roleTypeIDField, roleTypeCDField, ID, CD })
        },
        onPublicChange() {
            if (this.publicRole && this.publicRole.id != this.role.id && this.role.isPublic) {
                let warningMessage = this.$t('managers.rolesManagement.publicRoleWarning1') + `< ${this.publicRole.name} >` + this.$t('managers.rolesManagement.publicRoleWarning2')
                this.$confirm.require({
                    message: warningMessage,
                    header: this.$t('common.warning'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.role.isPublic = true
                        this.onFieldChange('isPublic', true)
                    },
                    reject: () => {
                        this.role.isPublic = false
                        this.onFieldChange('isPublic', false)
                    }
                })
            } else {
                this.onFieldChange('isPublic', this.role.isPublic)
            }
        }
    }
})
